import { render } from "./Unauthorised.vue?vue&type=template&id=028698fd"
import script from "./Unauthorised.vue?vue&type=script&lang=js"
export * from "./Unauthorised.vue?vue&type=script&lang=js"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__